__turbopack_context__.v({
  "advert": "AdvertTemplate-module-sass-module__znee-W__advert",
  "advert--is-dev": "AdvertTemplate-module-sass-module__znee-W__advert--is-dev",
  "advert-text": "AdvertTemplate-module-sass-module__znee-W__advert-text",
  "advert-wrap": "AdvertTemplate-module-sass-module__znee-W__advert-wrap",
  "visually-hidden": "AdvertTemplate-module-sass-module__znee-W__visually-hidden",
});
